module.exports = __webpack_public_path__ + "static/website-spa6-f07fd0aa0b878edf36df3104487a1147.png";